// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__n_15C","title":"ClientReferral_title__2i8wL","itemText":"ClientReferral_itemText__3sD42"};